<section class="container">
  <div class="inner">
    <header class="left">
      <a (click)="back()" class="link">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.4456 17.6569L6.48529 11.4362C6.33981 11.2856 6.26758 11.0905 6.26758 10.8962C6.26758 10.7018 6.33981 10.5065 6.48529 10.3561L12.4456 4.13542C12.7435 3.82312 13.2379 3.81296 13.5491 4.11203C13.8624 4.40906 13.8726 4.90565 13.5725 5.21587L8.10373 10.9255L13.5715 16.5765C13.8716 16.8857 13.8615 17.3831 13.5482 17.6803C13.2369 17.9795 12.7418 17.9691 12.4456 17.6569Z"
            fill="#FFFFFF" />
        </svg>
        <div class="whiteText">{{"Menu.back" | translate}}</div>
      </a>
    </header>
    <span class="greyText">{{"Home.Server.title" | translate}} {{servers.length}}</span>
    <div class="right">
      <div class="sort">
        <svg class="up" (click)="handleSort('asc')" width="12" height="6" viewBox="0 0 12 6" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M0.166504 5.33325L5.99984 0.333252L11.8332 5.33325H0.166504Z" fill="#C7C7C7" />
        </svg>
        <svg class="down" (click)="handleSort('desc')" width="12" height="6" viewBox="0 0 12 6" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M11.8332 0.666748L5.99984 5.66675L0.166504 0.666749L11.8332 0.666748Z" fill="#C7C7C7" />
        </svg>
      </div>
      <svg class="refresh" (click)="handleRefresh()" [class.rotating]="isRefreshing" width="20" height="20"
        viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.7085 5.29159C14.0917 4.67063 13.3581 4.17789 12.55 3.84178C11.742 3.50567 10.8753 3.33284 10.0001 3.33325C6.3168 3.33325 3.3418 6.31659 3.3418 9.99992C3.3418 13.6833 6.3168 16.6666 10.0001 16.6666C13.1085 16.6666 15.7001 14.5416 16.4418 11.6666H14.7085C14.3652 12.6412 13.7279 13.4852 12.8846 14.0823C12.0412 14.6793 11.0334 15 10.0001 14.9999C7.2418 14.9999 5.00013 12.7583 5.00013 9.99992C5.00013 7.24159 7.2418 4.99992 10.0001 4.99992C11.3835 4.99992 12.6168 5.57492 13.5168 6.48325L10.8335 9.16659H16.6668V3.33325L14.7085 5.29159Z"
          fill="#C7C7C7" />
      </svg>
    </div>
  </div>

  <section class="servers">
    <div *ngFor="let server of servers; let i = index" class="server"
      [class.active]="server.name === currentServer?.name" (click)="selectServer(server)">
      <div class="serverLeft">
        <span class="image" alt="flag">{{getCountryFlag(server.name)}}</span>
        <div class="serverName">{{server.name}}</div>
      </div>
      <div class="serverRight">
        <span class="ms">{{getLatencyText(server)}}</span>
        <div class="circle" [class.green]="getLatencyColor(server) === 'green'"
          [class.yellow]="getLatencyColor(server) === 'yellow'" [class.red]="getLatencyColor(server) === 'red'"
          [class.grey]="getLatencyColor(server) === 'grey'">
        </div>
        <img *ngIf="i === currentServer?.id" src="assets/images/ok.png" class="ok" alt="ok">
      </div>
    </div>
  </section>
</section>